const TOPICS = [
  { name: '明星塌房', count: '12.8万', hot: true },
  { name: '直播翻车', count: '9.6万', hot: true },
  { name: '综艺名场面', count: '8.2万', hot: true },
  { name: '网红实锤', count: '7.5万', hot: false },
  { name: '圈内爆料', count: '6.8万', hot: true },
  { name: '饭圈大战', count: '6.1万', hot: false },
  { name: '税务风波', count: '5.4万', hot: true },
  { name: '婚变传闻', count: '4.9万', hot: false },
  { name: '热搜追踪', count: '4.2万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            话题热榜
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            当前最火的话题标签，点击探索更多精彩内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {TOPICS.map((topic) => (
            <a
              key={topic.name}
              href="#cards"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 md:px-5 md:py-3 rounded-full text-sm font-medium transition-colors cursor-pointer no-underline whitespace-nowrap border ${
                topic.hot
                  ? 'bg-primary-50 text-primary-700 border-primary-200 hover:bg-primary-100'
                  : 'bg-background-100 text-foreground-700 border-background-200/60 hover:bg-background-200'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-accent-500 text-xs"></i>}
              <span>#{topic.name}</span>
              <span className="text-xs opacity-60">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}